<template>
  <div class="centerPage">
    <div class="pageTit">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/indication/list' }">病症管理</el-breadcrumb-item>
        <el-breadcrumb-item>病症详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-collapse accordion v-model="activeNames">
      <el-collapse-item title="信息编辑" name="1">
        <el-form ref="form" class="article_edit">
          <el-form-item label="中文名：">
            <el-input v-model="indicationData.cnName" placeholder="请输入中文名">
            </el-input>
          </el-form-item>
          <el-form-item label="英文名：">
            <el-input v-model="indicationData.enName" placeholder="请输入英文名">
            </el-input>
          </el-form-item>
          <el-form-item label="缩略图：">
            <el-upload
                v-if="indicationData.thumbnailPath"
                :limit="1"
                :action="uploadUrl"
                name="uploadFile"
                list-type="picture-card"
                class="uploadImg"
                :on-success="handleImageSuccess">
              <div v-if="imageUrl">只能上传一张图
              </div>
              <div v-else class="maxHeight">
                <div v-if="imageUrl"></div>
                <div v-else :style="'backgroundImage: url('+indicationData.thumbnailPath+')'" class="img"></div>
              </div>
            </el-upload>
            <el-upload
                v-else
                :limit="1"
                :action="uploadUrl"
                name="uploadFile"
                list-type="picture-card"
                class="uploadImg"
                :on-success="handleImageSuccess">
              <span slot="default">点击上传</span>
            </el-upload>
          </el-form-item>
          <el-form-item label="状态：">
            <el-radio-group v-model="indicationData.status" class="type">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="简述：">
            <el-input v-model="indicationData.briefDesc" placeholder="请输入简述"
                      :autosize="{ minRows: 2, maxRows: 5}" type="textarea">
            </el-input>
          </el-form-item>
          <el-form-item label="治疗方法：">
            <!--            (此处将来改成富文本编辑器)-->
            <el-input v-model="indicationData.remedies" placeholder="请输入治疗方法"
                      :autosize="{ minRows: 2, maxRows: 10}" type="textarea">
            </el-input>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model="indicationData.remark" placeholder="请输入备注"
                      :autosize="{ minRows: 2, maxRows: 5}" type="textarea">
            </el-input>
          </el-form-item>
          <div class="btn">
            <el-button @click="saveUpdate" v-if="indicationId">更新</el-button>
            <el-button @click="saveUpdate" v-else>添加</el-button>
          </div>
        </el-form>
      </el-collapse-item>
      <el-collapse-item title="推荐医师" v-if="indicationId" name="2">
        <div style="text-align: center;">
          <el-transfer
              v-model="selectDoctors"
              :data="doctorsData"
              target-order="push"
              filterable
              filter-placeholder="请输入医师姓名"
              :titles="['可选医师', '已选医师']"
              style="text-align: left; display: inline-block;">
          </el-transfer>
        </div>
        <el-button @click="changeSelect(1)" type="primary">改变推荐医师</el-button>
      </el-collapse-item>
      <el-collapse-item title="推荐心理测试" v-if="indicationId" name="3">
        <div style="text-align: center;">
          <el-transfer
              v-model="selectExam"
              :data="examData"
              target-order="push"
              filterable
              filter-placeholder="请输入测试名字"
              :titles="['可选测试', '已选测试']"
              style="text-align: left; display: inline-block;">
          </el-transfer>
        </div>
        <el-button @click="changeSelect(3)" type="primary">改变推荐测试</el-button>
      </el-collapse-item>
    </el-collapse>


  </div>
</template>

<script>
import commonjs from "../../../api/common";

export default {
  name: "indicationEdit.vue",
  data() {
    return {
      activeNames: "1",
      indicationId: this.$route.query.id,
      indicationData: {
        briefDesc: '',
        cnName: '',
        enName: '',
        remark: '',
        remedies: '',
        status: 1,
        thumbnailPath: '',
      },//病症数据
      imageUrl: '',// 新增上传组件显示上传的图片
      uploadUrl: commonjs.uploadUrl + "indication" || ' ',

      doctorsData: [],//医师数据
      selectDoctors: [],//选择的医师

      examData: [],//测试数据
      selectExam: [],//选择的测试
    }
  },
  mounted() {
    if (this.indicationId != null) {
      this.getData();
      this.getDoctors();//可推荐的医师
      this.getExams();//可推荐的测试
      this.getRecommend(1);//已推荐的医师
      this.getRecommend(3);//已推荐的测试
    }
  },
  methods: {
    //获得数据
    getData() {
      let that = this;
      this.$ajax
          .get(commonjs.api.indication.edit.detail.replace("{indicationId}", this.indicationId))
          .then(function (res) {
            if (res.data.status === 'success') {
              that.indicationData = res.data.data;
            }
          })
    },
    //更新或添加
    saveUpdate() {
      let that = this;
      this.$ajax
          .post(commonjs.api.indication.edit.saveUpdate.replace("{indicationId}", this.indicationId), this.indicationData)
          .then(function (res) {
            if (res.data.status === 'success') {
              that.$message({
                message: res.data.message,
                type: 'success'
              })
            } else {
              that.$message.error(res.data.message);
            }
            that.$router.push({name: 'indicationList'});
          }).catch((err) => {
        console.error(err);
        that.$message.error('操作失败');
      })
    },
    //上传图片
    handleImageSuccess(res, file) {// 新增上传组件
      this.imageUrl = URL.createObjectURL(file.raw);
      this.indicationData.thumbnailPath = res.message;
    },
    //查询可推荐的医师
    getDoctors() {
      let that = this;
      this.$ajax
          .get(commonjs.api.doctor.baseAll)
          .then(function (res) {
            let data = [];
            $(res.data.list).each((index, obj) => {
              data.push({
                key: obj.id,
                label: obj.fullName
              })
            });
            that.doctorsData = data;
          })
    },
    //查询可推荐的心理测试
    getExams() {
      let that = this;
      this.$ajax
          .get(commonjs.api.exam.baseAll)
          .then(function (res) {
            let data = [];
            $(res.data.list).each((index, obj) => {
              data.push({
                key: obj.id,
                label: obj.title
              })
            });
            that.examData = data;
          })
    },
    //查询已推荐的医师/心理测试
    getRecommend(type) {
      let that = this;
      this.$ajax
          .get(commonjs.api.indication.edit.recommend.list.replace("{type}/{indicationId}", type + "/" + this.indicationId))
          .then(function (res) {
            let data = [];
            $(res.data.list).each((index, obj) => {
              if (type === 3) {
                data.push(Number(obj.recommendId));
              } else {
                data.push(obj.recommendId);
              }
            });
            if (type === 1) {
              that.selectDoctors = data;
            } else if (type === 3) {
              that.selectExam = data;
            }
          })
    },
    //改变已选医师/心理测试
    changeSelect(type) {
      let that = this;
      if (type === 1) {
        this.$ajax.post(commonjs.api.indication.edit.recommend.update.replace("{type}/{indicationId}", type + "/" + this.indicationId), this.selectDoctors).then(function (res) {
          if (res.data.status === 'success') {
            that.$message.success('操作成功');
          } else {
            that.$message.error(res.data.message);
          }
        }).catch((err) => {
          console.error(err);
          that.$message.error('操作失败');
        })
      } else if (type === 3) {
        this.$ajax.post(commonjs.api.indication.edit.recommend.update.replace("{type}/{indicationId}", type + "/" + this.indicationId), this.selectExam).then(function (res) {
          if (res.data.status === 'success') {
            that.$message.success('操作成功');
          } else {
            that.$message.error(res.data.message);
          }
        }).catch((err) => {
          console.error(err);
          that.$message.error('操作失败');
        })
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/banner.scss';

.centerPage ::v-deep {
  display: block;
  width: auto;

  .el-collapse-item__content {
    max-height: 500px;
    overflow-y: scroll;
    padding-right: 20px;
  }

  .el-transfer-panel {
    width: 240px;

    .el-transfer-panel__filter {
      width: 90%;
    }
  }

  .el-form-item__content {
    width: 80%;
  }
}

</style>